import { render, staticRenderFns } from "./Membershipactivitiesdetails.vue?vue&type=template&id=47d818f1&scoped=true&"
import script from "./Membershipactivitiesdetails.vue?vue&type=script&lang=js&"
export * from "./Membershipactivitiesdetails.vue?vue&type=script&lang=js&"
import style0 from "./Membershipactivitiesdetails.vue?vue&type=style&index=0&id=47d818f1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d818f1",
  null
  
)

export default component.exports